// assets
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import CreditCardOutlined from '@ant-design/icons/CreditCardOutlined';
import CustomerServiceOutlined from '@ant-design/icons/CustomerServiceOutlined';

// icons
const icons = { DashboardOutlined, CreditCardOutlined, CustomerServiceOutlined };

// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages = {
  id: 'group-pages',
  title: '',
  type: 'group',
  children: [
    {
      id: 'dashboard1',
      title: 'dashboard',
      type: 'item',
      icon: icons.DashboardOutlined,
      url: '/dashboard',
      role: ['ROLE_RETAILER'],
      privilege: [],
    },
    {
      id: 'cards',
      title: 'Cards',
      type: 'collapse',
      icon: icons.CreditCardOutlined,
      role: ['ROLE_RETAILER'],
      privilege: [],
      children: [
        {
          id: 'card-details',
          title: 'Card Details',
          type: 'item',
          url: '/all-cards',
          role: ['ROLE_RETAILER'],
          privilege: [],
          // target: true
        }
      ]
    },
    {
      id: 'customer-support',
      title: 'Customer Support',
      type: 'item',
      url: '/all-tickets',
      icon: icons.CustomerServiceOutlined,
      // onlyForUsers: ['STRICT_ACCESS_ONLY'],
      role: ['ROLE_RETAILER'],
      privilege: [],
    }
  ]
};

export default pages;
